import { render, staticRenderFns } from "./ManageLabourerAssignmentPage.vue?vue&type=template&id=0dbfc9ce&scoped=true&"
import script from "./ManageLabourerAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./ManageLabourerAssignmentPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageLabourerAssignmentPage.vue?vue&type=style&index=0&id=0dbfc9ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfc9ce",
  null
  
)

export default component.exports